const locale = {
	APP_TITLE: 'Mailbox',
	COMPOSE: 'COMPOSE',
	FOLDERS: 'FOLDERS',
	FILTERS: 'FILTERS',
	LABELS: 'LABELS',
	NO_MESSAGES: 'There are no messages!',
	SEARCH_PLACEHOLDER: 'Search for an e-mail or contact',
	INBOX: 'Inbox',
	SENT: 'Sent',
	DRAFTS: 'Drafts',
	SPAM: 'Spam',
	TRASH: 'Trash',
	STARRED: 'Starred',
	IMPORTANT: 'Important'
};

export default locale;
